var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateBtnIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.9 10C0.9 15.018 4.98197 19.1 10 19.1C15.018 19.1 19.1 15.018 19.1 10C19.1 4.98197 15.018 0.9 10 0.9C4.98197 0.9 0.9 4.98197 0.9 10ZM2.225 10C2.225 5.71275 5.71275 2.225 10 2.225C14.2873 2.225 17.775 5.71275 17.775 10C17.775 14.2873 14.2873 17.775 10 17.775C5.71275 17.775 2.225 14.2873 2.225 10Z",
    fill: "#CC5A5A",
    stroke: "#CC5A5A",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0625 10.6625H13.9375C14.3032 10.6625 14.6 10.3657 14.6 10C14.6 9.63427 14.3032 9.3375 13.9375 9.3375H6.0625C5.69677 9.3375 5.4 9.63427 5.4 10C5.4 10.3657 5.69677 10.6625 6.0625 10.6625Z",
    fill: "#CC5A5A",
    stroke: "#CC5A5A",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3375 13.9375C9.3375 14.3032 9.63427 14.6 10 14.6C10.3657 14.6 10.6625 14.3032 10.6625 13.9375V6.0625C10.6625 5.69677 10.3657 5.4 10 5.4C9.63427 5.4 9.3375 5.69677 9.3375 6.0625V13.9375Z",
    fill: "#CC5A5A",
    stroke: "#CC5A5A",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateBtnIcon);
export default __webpack_public_path__ + "static/media/create-btn-icon.4795a5f7d060824b9fad3338b78e56a2.svg";
export { ForwardRef as ReactComponent };